import { Component, OnInit, ViewEncapsulation, AfterViewInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiContentService } from '../../api/api-content.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MapsAPILoader, MouseEvent } from '@agm/core';
import swal from 'sweetalert/dist/sweetalert.min.js';

@Component({
  selector: 'app-regisnew',
  templateUrl: './updateprofile.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./regisnew.component.css'],
  styles: [`
    .light-blue-backdrop {
      background-color: #5cb3fd;
    }
  `]
})
export class UpdateprofileComponent implements OnInit {
  
  constructor(
    private route:ActivatedRoute,
	  public rest:ApiContentService,
    private fb: FormBuilder,  
    private router: Router,
    private modalService: NgbModal,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone
  ) { }

  loadingIcon:any = {
    showLocation: false
  }

  formSet= this.fb.group({
    name: [''],
    id_number:[''],
    typeidentity:[''],
    celular_number:[''],
    celular_wa:[''],
    name_relative:[''],
    phone_relative:[''],
    email:[''], 
    date_birth:[''],
    idtype_identity:[''],
    //rt:[''], 
    //rw:[''],
    kodepos:[''],
    //type_id:['']
  })

  submitted = true;

  prospekindex:any
  dataprospek:any = {
    'prospek_id':null
  }
  dataprospekinstall:any = {}
  dataprospekidentity:any = {}
  dataprospekorder:any = {}
  latitude: number
  longitude: number
  zoom: number
  data_kml:any = []
  tea:any = []
  hometype:any = []
  homestatus:any = []
  typeidentity:any = []
  typerelative:any = []

  ngOnInit(){
    this.prospekindex = this.route.snapshot.params.prospekindex
    this.getProspect();
    this.loadTypeidentity();
    this.loadHometype(); 
    this.loadHomestatus();
    this.loadTyperelative();
  }

  showLocation(){
    this.loadingIcon.showLocation = true
  }

  getProspect(){
    //this.loadingIcon.prospek_summary = true
    const dataPost = {}
    dataPost['prospekindex'] = this.prospekindex

    this.rest.getProspekinfo(dataPost)
    .subscribe((response: any) => {
      //this.loadingIcon.prospek_summary = false
      console.log(response); 



      if(response.status){
        this.dataprospek = response.data.prospect
        this.dataprospekinstall = response.data.prospect_install
        this.dataprospekidentity = response.data.prospect_identity
        this.dataprospekorder = response.data.prospect_order
        console.log("siska")
        console.log(this.dataprospekidentity["celular_number"])
        
        this.latitude = parseFloat(this.dataprospekinstall.latitude)
        this.longitude = parseFloat(this.dataprospekinstall.longitude)
        this.zoom = 17

        this.formSet.get("name").setValue(this.dataprospekidentity["name"])
        this.formSet.get("typeidentity").setValue(this.dataprospekidentity["typeidentity"])
        this.formSet.get("celular_number").setValue(this.dataprospekidentity["celular_number"])
        this.formSet.get("celular_wa").setValue(this.dataprospekidentity["celular_wa"])
        this.formSet.get("name_relative").setValue(this.dataprospekidentity["name_relative"])
        this.formSet.get("phone_relative").setValue(this.dataprospekidentity["phone_relative"])
        this.formSet.get("email").setValue(this.dataprospekidentity["email"])

        this.formSet.get("date_birth").setValue(this.dataprospekidentity["birth"])
        this.formSet.get("id_number").setValue(this.dataprospekidentity["id_number"])
        //this.formSet.get("rt").setValue(this.dataprospekidentity["rt"])
        //this.formSet.get("rw").setValue(this.dataprospekidentity["rw"])
        this.formSet.get("kodepos").setValue(this.dataprospekidentity["postalcode"])
        this.formSet.get("idtype_identity").setValue(this.dataprospekidentity["type_id"])
        
        //this.formSet.get("type_id").setValue(this.typeidentity["id"])


        this.getIkrgis()
      }else{
        alert(response.message)
      }

    });
  }

  submitUpdate(){
    swal({
      title: "Are you sure?",
      text: "Form akan disubmit",
      icon: "warning",
      buttons: true,
      dangerMode: true,
      closeOnClickOutside: false
    })
    .then((confirm) => {
      if (confirm) {
        this.rest.updateProspekdetail(this.prospekindex, this.formSet.value).subscribe((response: any) =>{
          if(response.status == true){
            this.alertsuccess(response.message)
          }else{
            this.alertfailed(response.message)
          }
        })
      }
    })
  }

  nexttoOrder(){
    this.submitted = false;
    //alert(this.prospekindex);
    // this.ngOnInit();
    this.router.navigate(['regis2/'+this.prospekindex]);
  }

  

  getIkrgis(){
    const params2 = {
        "city_id":this.dataprospekinstall.city,
        "subdistrict_name":this.dataprospekinstall.subdistrict_name
    }
    this.rest.getIkrgis(params2).subscribe((response:any) => {

      if(response.status){

        response.data.forEach((row:any) => {
          this.data_kml.push(
            {
              'src': "gis/"+row.dir + "/kml/" + row.area
            }
          )
        });
        response.data.forEach((row:any) => {
          this.data_kml.push(
            {
              'src': "gis/"+row.dir + "/kml/" + row.area_detail
            }
          )
        });
        // console.log(this.data_kml)
        this.data_kml.forEach((v:any, i:any) => {
            this.rest.getMapGeojson(v).subscribe((response:any) => {
              console.log(response);
              this.tea[i] = response.data
            });
          });

      }else{
        console.log(response);
      }

    });
  }

  loadHomestatus(){
    this.rest.getSgshomestatus().subscribe((response:any) => {
      // console.log(response)
      this.homestatus = response.data
    });
  }
  loadHometype(){
    this.rest.getSgshometype().subscribe((response:any) => {
      // console.log(response)
      this.hometype = response.data
    });
  }
  loadTypeidentity(){
    this.rest.getSgstypeidentity().subscribe((response:any) => {
      console.log(response)
      console.log("siska22222");
      this.typeidentity = response.data
    });
  }
  loadTyperelative(){
    this.rest.getSgstyperelative().subscribe((response:any) => {
      
      //console.log(response)
      this.typerelative = response.data
    });
  }

  alertfailed(message:any){
    swal({
      title: "Gagal!",
      text: message,
      icon: "error"
    })
  }
  alertsuccess(message:any){
    swal({
      title: "Sukses!",
      text: message,
      icon: "success",
      // closeOnClickOutside: false
    })
  }

  }

  